/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DeclarationType {
    BENEFICIAL_OWNERSHIP = 'BENEFICIAL_OWNERSHIP',
    POLITICALLY_EXPOSED_PERSON = 'POLITICALLY_EXPOSED_PERSON',
    SOURCE_OF_FUNDS_SALARY = 'SOURCE_OF_FUNDS_SALARY',
    SOURCE_OF_FUNDS_INHERITANCE = 'SOURCE_OF_FUNDS_INHERITANCE',
    SOURCE_OF_FUNDS_INVESTMENT_INCOME = 'SOURCE_OF_FUNDS_INVESTMENT_INCOME',
    SOURCE_OF_FUNDS_PERSONAL_SAVINGS = 'SOURCE_OF_FUNDS_PERSONAL_SAVINGS',
    SOURCE_OF_FUNDS_OTHER = 'SOURCE_OF_FUNDS_OTHER',
}
